import { render, staticRenderFns } from "./BaseDangerButton.vue?vue&type=template&id=dceba51c&scoped=true"
import script from "./BaseDangerButton.vue?vue&type=script&lang=js"
export * from "./BaseDangerButton.vue?vue&type=script&lang=js"
import style0 from "./BaseDangerButton.vue?vue&type=style&index=0&id=dceba51c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dceba51c",
  null
  
)

export default component.exports